import Api from "../../../util/Api";

export default function getInitState() {
    return {
        labTableShow: true,
        labFormShow: false,
        patientLabTableShow: false,
        patientLabFormShow: false,

        labTableRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showLabs',
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteLab',
                additionalButtonVisible: "hasCallCenterRoleAndIsDeleteable"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow',
                additionalButtonVisible: "unDeleteVisible"
            }
        ],
        labTableSearchFields: [
            {
                label: "Név",
                name: "patientName",
                formSize: 4,
                formType: 'text',
                formVisible: true
            },
            {
                name: "siteId",
                label: "Ellátóhely",
                visibility: false,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4
            },
            {
                label: "Laborba küldés időpontjától",
                name: 'appointmentFrom',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                label: "Laborba küldés időpontjáig",
                name: 'appointmentTo',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                label: "Határidőtől",
                name: 'resultDateFrom',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                label: "Határidőig",
                name: 'resultDateTo',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 4,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "statusId",
                label: "Állapot",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllLabHandleStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "patientSocialInsuranceNumber",
                label: "TAJ szám",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
            {
                label: "Technikai azonosító",
                name: "prefixedId",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
            {
                label: "Labortípus",
                name: "labTypeNames",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
        ],
        patientLabTableSearchFields: [
            {
                name: "siteId",
                label: "Ellátóhely",
                visibility: false,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getCompanySitesByCompanyId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'keresés',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4
            },
            {
                label: "Laborba küldés időpontjától",
                name: 'appointmentFrom',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                label: "Laborba küldés időpontjáig",
                name: 'appointmentTo',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                label: "Határidőtől",
                name: 'resultDateFrom',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                label: "Határidőig",
                name: 'resultDateTo',
                formSize: 4,
                formType: 'date',
                formVisible: true
            },
            {
                name: "doctorId",
                label: "Orvos",
                formSize: 4,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "statusId",
                label: "Állapot",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllLabHandleStatus,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                label: "Labortípus",
                name: "labTypeNames",
                formType: "text",
                formSize: 4,
                formVisible: true,
            },
        ],
        labTableAdditionalConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        labTableHeaderFields: [
            {
                label: "Azonosító",
                name: "id",
                visibility: false
            },
            {
                name: "isSynlabType",
                label: "",
                visibility: true,
                slot_name: 'is_synlab_type_icon_for_labs',
            },
            {
                label: "Név",
                name: "patient.name",
                sort: true
            },
            {
                label: "Születési hely",
                name: "patient.placeOfBirth",
            },
            {
                label: "Születési idő",
                name: "patient.dateOfBirth",
                slot_name: "birthdate_format"
            },
            {
                label: "TAJ szám",
                name: "patient.socialInsuranceNumber",
            },
            {
                label: "Technikai azonosító",
                name: "patient.prefixedId",
            },
            {
                label: "Orvos",
                name: "doctor.fullName",
                sort: true
            },
            {
                label: "Labortípus",
                name: "labTypeNames",
            },
            {
                label: "Ellátóhely",
                name: "companySite.siteName",
                visibility: true,
                sort: true
            },
            {
                label: "Laborba küldés dátuma",
                name: "startDate",
                slot_name: "startdate_format",
                sort: true
            },
            {
                label: "Határidő",
                name: "resultDate",
                slot_name: "resultdate_format",
                sort: true
            },
            {
                label: "Állapot",
                name: "status.text",
                sort: true
            },
            {
                label: "Opciók",
                name: "buttons",
                sort: false
            }
        ],
        labFormFields: [
            {
                name: "doctorId",
                label: "Orvos",
                formType: "select",
                formRequired: true,
                formSize: 2,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
        ],
        patientLabTableHeaderFields: [
            {
                name: "isSynlabType",
                label: "",
                visibility: true,
                slot_name: 'is_synlab_type_icon_for_labs',
            },
            {
                name: "id",
                label: "Azonosító",
                visibility: false
            },
            {
                name: "doctor.fullName",
                label: "Orvos",
                visibility: true
            },
            {
                name: "labTypeNames",
                label: "Labor típus",
                visibility: true
            },
             {
                label: "Ellátóhely",
                name: "companySite.siteName",
                visibility: true,
                sort: true
            },
            {
                name: "resultDate",
                label: "Határidő",
                visibility: true,
                slot_name: "resultDate_format"
            },
            {
                name: "startDate",
                label: "Laborba küldés dátuma",
                visibility: true,
                slot_name: "startDate_format"
            },
            {
                name: "emailSentDateTimeFormatted",
                label: "Email kiküldve",
                visibility: true,
                slot_name: "email_sent_date_time"
            },
            {
                name: "status.text",
                label: "Állapot",
                visibility: true
            },
            {
                name: "attendanceId",
                label: "Ellátás azonosító",
                visibility: false
            },
            {
                name: "company",
                label: "Company",
                visibility: false
            },
            {
                name: "companyId",
                label: "Cég azonosító",
                visibility: false
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false
            },
            {
                name: "deleted",
                label: "Státusz",
                visibility: false
            },
            {
                name: "doctor",
                label: "Doctor",
                visibility: false
            },
            {
                name: "doctorId",
                label: "Orvos azonosító",
                visibility: false
            },
            {
                name: "fileName",
                label: "Fájl név",
                visibility: false
            },
            {
                name: "filePath",
                label: "Fájl útvonal",
                visibility: false
            },
            {
                name: "labType",
                label: "LabType",
                visibility: false
            },
            {
                name: "labTypeId",
                label: "Labor típus azonosító",
                visibility: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false
            },
            {
                name: "patient",
                label: "Páciens",
                visibility: false
            },
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false
            },
            {
                name: "status",
                label: "Status",
                visibility: false
            },
            {
                name: "statusId",
                label: "Állapot azonosító",
                visibility: false
            },
            {
                name: "eesztId",
                label: "EESZT azonosító",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ],
        patientLabTableRowActions: [
            {
                btn_text: '<i class="fas fa-share-square"></i>',
                title: 'Kiküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'sendLabDocument',
                additionalButtonVisible: "userHasSendLabPermission"
            },
            {
                btn_text: '<i class="fas fa-file-import"></i>',
                title: 'Azonnali beküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'sendImmediately',
                additionalButtonVisible: "isNotSynlabSent"
            },
            {
                btn_text: '<i class="fas fa-file-pdf"></i>',
                title: 'PDF megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadLabDocument',
                additionalButtonVisible: "hasCallCenterRole"
            },
            {
                btn_text: '<i class="fa fa-print"></i>',
                title: 'Etikett címke nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'printLabEtikettSticker',
                additionalButtonVisible: "isReadyForEtikett"
            },
            {
                btn_text: '<i class="fas fa-file-invoice-dollar"></i>',
                title: 'Árajánlat nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'printPriceOffer',
            },
            {
                btn_text: '<i class="fas fa-atom"></i>',
                title: 'Rákkeltő protokoll indítása',
                event_name: "customClick",
                class: "btn btn-outline-purple",
                event_payload: 'startCarcinogenicProtocol',
                additionalButtonVisible: "canCarcinogenicProtocolStart"
            },
            {
                btn_text: '<i class="fas fa-microscope"></i>',
                title: 'Labor eredmények',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'showLabResults',
                additionalButtonVisible: "isSynlabTypeAndNotDeleted"
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'editLab',
                additionalButtonVisible: "hasCallCenterRoleAndIsEditable"
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deletePatientLab',
                additionalButtonVisible: "hasCallCenterRoleAndIsDeleteable"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow',
                additionalButtonVisible: "unDeleteVisible"
            }
        ],
        patientLabTableRowActionsViewOnly: [
            {
                btn_text: '<i class="fas fa-file-pdf"></i>',
                title: 'PDF megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadLabDocument'
            },
        ],
        editLabFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToPatientLabTable'
            }
        ],
        editLabFormFields: [
            {
                name: "id",
                label: "Azonosító",
                formVisible: false
            },
            {
                name: "patientId",
                label: "Páciens ID",
                formVisible: false,
            },
            {
                name: "patientName",
                label: "Páciens",
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 6
            },
            {
                name: "doctorFullName",
                label: "Orvos",
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 6
            },
            {
                name: "doctorId",
                label: "Orvos",
                formType: "select",
                formRequired: true,
                formSize: 3,
                formReadOnly: true,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "labTypeId",
                label: "Labor típus",
                formType: "select",
                formRequired: true,
                formSize: 3,
                formVisible: true,
                formReadOnly: false,
                selectOptions: {
                    apiCallback: Api.getAllLabHandleType,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "statusId",
                label: "Állapot",
                formType: "select",
                formRequired: true,
                formSize: 2,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllLabHandleStatus,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
            },
            {
                name: "startDate",
                label: "Laborba küldés dátuma",
                formType: "date",
                formRequired: true,
                formSize: 2,
                formVisible: true
            },
            {
                name: "resultDate",
                label: "Határidő",
                formType: "date",
                formRequired: true,
                formSize: 2,
                formVisible: true
            }
        ],
        patientDetailsLabTableRowActions: [
            {
                btn_text: '<i class="fas fa-file-pdf"></i>',
                title: 'PDF megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadLabDocument'
            },
            {
                btn_text: '<i class="fas fa-share-square"></i>',
                title: 'Kiküldés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'sendLabDocument',
                additionalButtonVisible: "userHasSendLabPermission"
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Egészségügyi dokumentum',
                title: 'Rögzítés EESZT-be',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showSendEHR',
                additionalButtonVisible: "isShowSendEHR"
            },
            {
                btn_text: '<i class="fa fa-print"></i>',
                title: 'Árajánlat nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'printLabBid',
                additionalButtonVisible: "isShowCovidButtons"
            },
            {
                btn_text: '<i class="fa fa-print"></i>',
                title: 'Etikett címke nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'printLabEtikettSticker',
                additionalButtonVisible: "isShowCovidButtons"
            }
        ],
        dataTableOptions: {
            server_mode: true,
            per_page: 10,
            pagination: false,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
    }
}
